import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import { useInputLogic } from './hooks';

/**
 * 输入框组件，支持添加前后缀。
 * @en The input box, supports adding prefixes and suffixes.
 * @type 数据输入
 * @type_en Data Entry
 * @name 输入框
 * @name_en Input
 */
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
      name = props.name,
      maxLength = props.maxLength,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      onKeyUp = props.onKeyUp,
      onKeyPress = props.onKeyPress,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      disabled = props.disabled,
      pattern = props.pattern,
      inputClass = props.inputClass,
      inputStyle = props.inputStyle,
      _props$nativeProps = props.nativeProps,
      nativeProps = _props$nativeProps === void 0 ? {} : _props$nativeProps;
  var inputRef = useRef(null);

  var _useInputLogic = useInputLogic(props, inputRef),
      inputValue = _useInputLogic.inputValue,
      handleChange = _useInputLogic.handleChange,
      handleInput = _useInputLogic.handleInput,
      handleKeyDown = _useInputLogic.handleKeyDown,
      handleFocus = _useInputLogic.handleFocus,
      handleBlur = _useInputLogic.handleBlur,
      handleClick = _useInputLogic.handleClick,
      renderWrapper = _useInputLogic.renderWrapper,
      wrapRef = _useInputLogic.wrapRef;

  useImperativeHandle(ref, function () {
    return {
      dom: wrapRef.current,
      input: inputRef.current
    };
  });

  function renderInput(_ref) {
    var prefixCls = _ref.prefixCls;
    var prefix = prefixCls + "-input";
    return renderWrapper(prefix, type, /*#__PURE__*/React.createElement("input", _extends({}, nativeProps, {
      id: id,
      name: name,
      maxLength: maxLength,
      placeholder: placeholder,
      readOnly: readOnly,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyUp: onKeyUp,
      onKeyPress: onKeyPress,
      ref: inputRef,
      className: cls(prefix, inputClass),
      style: inputStyle,
      value: inputValue,
      type: type,
      disabled: disabled,
      pattern: pattern,
      onChange: handleChange,
      onInput: handleInput,
      onKeyDown: handleKeyDown,
      onClick: handleClick
    })));
  }

  return /*#__PURE__*/React.createElement(ContextLayout, null, renderInput);
});
export default Input;